import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ProductNavbar from '../../ProductNavbar';
import LeftSidebarUpper from '../../LeftSidebarUpper';
import LeftSidebarDown from '../../LeftSidebarDown';
import RightProductSection from '../../RightProductSection';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Vests = () => {
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showFilters, setShowFilters] = useState(true);
  const [sortBy, setSortBy] = useState('popularity');
  const [showMobileFilters, setShowMobileFilters] = useState(false);
  const [showMobileSortModal, setShowMobileSortModal] = useState(false);
  const [selectedMobileFilterCategory, setSelectedMobileFilterCategory] = useState('brands');

  const [selectedFilters, setSelectedFilters] = useState({
    gender: [],
    kids: [],
    price: [],
    sale: [],
    sports: [],
    colour: [],
    features: [],
    fit: [],
    brand: [],
    technology: [],
    bestFor: [],
    material: [],
  });

  const subcategoryBrands = [
    'Jockey',
    'Lux',
    'Rupa',
    'Levi\'s',
    'Van Heusen',
    'Marks & Spencer',
    'Peter England',
    'Amul',
    'Dollar',
    'Hanes',
    'Fruit of the Loom',
    'Dixcy Scott',
  ];

  useEffect(() => {
    fetchProducts();
  }, []);
  useEffect(() => {
    applyFiltersAndSort();
  }, [products, selectedFilters, sortBy]);

  const fetchProducts = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API}/products?category=Fashion`);
      const subcategoryProducts = response.data.filter(
        (p) => p.category === 'Innerwear & Sleepwear' && p.subcategory === 'Vests'
      );
      setProducts(subcategoryProducts);
      setFilteredProducts(subcategoryProducts);
    } catch (error) {
      console.error('Error fetching products:', error);
    } finally {
      setLoading(false);
    }
  };

  const applyFiltersAndSort = () => {
    let filtered = [...products];
    Object.keys(selectedFilters).forEach((filterKey) => {
      if (selectedFilters[filterKey].length > 0) {
        filtered = filtered.filter((product) => {
          if (filterKey === 'price') {
            const price = product.price;
            return selectedFilters[filterKey].some((range) => {
              if (range === 'Under ₹ 2 500.00') return price < 2500;
              if (range === '₹ 2 501.00 - ₹ 7 500.00') return price >= 2501 && price <= 7500;
              if (range === '₹ 7 501.00 - ₹ 12 999.00') return price >= 7501 && price <= 12999;
              if (range === 'Over ₹ 13 000.00') return price > 13000;
              return false;
            });
          }
          return selectedFilters[filterKey].includes(product[filterKey]);
        });
      }
    });
    switch (sortBy) {
      case 'price-low-high':
        filtered.sort((a, b) => a.price - b.price);
        break;
      case 'price-high-low':
        filtered.sort((a, b) => b.price - a.price);
        break;
      case 'whats-new':
        filtered.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        break;
      case 'better-discount':
        filtered.sort((a, b) => b.discount - a.discount);
        break;
      case 'customer-rating':
        filtered.sort((a, b) => b.rating - a.rating);
        break;
      default:
        break;
    }
    setFilteredProducts(filtered);
  };

  const handleFilterChange = (category, value) => {
    setSelectedFilters((prev) => {
      const current = prev[category];
      const newValues = current.includes(value) ? current.filter((item) => item !== value) : [...current, value];
      return { ...prev, [category]: newValues };
    });
  };

  return (
    <div className="min-h-screen bg-white pb-20 md:pb-0">
      <ProductNavbar
        category="Vests"
        breadcrumbs="Men Innerwear & Sleepwear / Vests"
        sortBy={sortBy}
        onSortChange={setSortBy}
      />
      <div className="max-w-screen-2xl mx-auto px-4 lg:px-16">
        <div className="flex gap-8 py-8">
          {showFilters && (
            <aside className="hidden lg:block w-64 flex-shrink-0">
              <LeftSidebarUpper category="innerwear-sleepwear" />
              <div className="mb-8 mt-6">
                <h3 className="font-bold text-sm mb-4">BRANDS</h3>
                <div className="space-y-2 max-h-96 overflow-y-auto">
                  {subcategoryBrands.map((brand) => (
                    <label key={brand} className="flex items-center py-1 cursor-pointer hover:text-pink-600">
                      <input
                        type="checkbox"
                        className="mr-3 w-4 h-4 accent-pink-600"
                        checked={selectedFilters.brand.includes(brand)}
                        onChange={() => handleFilterChange('brand', brand)}
                      />
                      <span className="text-sm text-gray-700">{brand}</span>
                    </label>
                  ))}
                </div>
              </div>
              <LeftSidebarDown selectedFilters={selectedFilters} onFilterChange={handleFilterChange} />
            </aside>
          )}
          <main className="flex-1">
            <RightProductSection products={filteredProducts} loading={loading} />
          </main>
        </div>
      </div>
      <div className="lg:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-300 flex z-50">
        <button
          onClick={() => setShowMobileSortModal(true)}
          className="flex-1 py-4 flex items-center justify-center gap-2 border-r border-gray-300"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4h13M3 8h9m-9 4h6m4 0l4-4m0 0l4 4m-4-4v12" />
          </svg>
          <span className="font-semibold">SORT</span>
        </button>
        <button onClick={() => setShowMobileFilters(true)} className="flex-1 py-4 flex items-center justify-center gap-2">
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
            />
          </svg>
          <span className="font-semibold">FILTER</span>
        </button>
      </div>
      {showMobileSortModal && (
        <div className="lg:hidden fixed inset-0 bg-black bg-opacity-50 z-50" onClick={() => setShowMobileSortModal(false)}>
          <div className="absolute bottom-0 left-0 right-0 bg-white rounded-t-2xl" onClick={(e) => e.stopPropagation()}>
            <div className="p-6">
              <div className="flex items-center justify-between mb-6">
                <h3 className="text-xl font-bold">SORT BY</h3>
                <button onClick={() => setShowMobileSortModal(false)}>
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
              <div className="space-y-1">
                {[
                  { value: 'popularity', label: 'Popularity', icon: '🔥' },
                  { value: 'whats-new', label: 'Latest', icon: '⭐' },
                  { value: 'better-discount', label: 'Discount', icon: '💰' },
                  { value: 'price-high-low', label: 'Price: High to Low', icon: '₹' },
                  { value: 'price-low-high', label: 'Price: Low to High', icon: '₹' },
                  { value: 'customer-rating', label: 'Customer Rating', icon: '⭐' },
                ].map((option) => (
                  <button
                    key={option.value}
                    onClick={() => {
                      setSortBy(option.value);
                      setShowMobileSortModal(false);
                    }}
                    className={`w-full text-left px-4 py-4 flex items-center gap-3 hover:bg-gray-50 ${
                      sortBy === option.value ? 'text-pink-600 font-semibold' : 'text-gray-700'
                    }`}
                  >
                    <span className="text-xl">{option.icon}</span>
                    <span>{option.label}</span>
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
      {showMobileFilters && (
        <div className="lg:hidden fixed inset-0 bg-white z-50 flex flex-col">
          <div className="sticky top-0 bg-white border-b border-gray-300 px-4 py-4 flex items-center justify-between">
            <h3 className="text-lg font-bold">FILTERS</h3>
            <div className="flex items-center gap-4">
              <button
                onClick={() =>
                  setSelectedFilters({
                    gender: [],
                    kids: [],
                    price: [],
                    sale: [],
                    sports: [],
                    colour: [],
                    features: [],
                    fit: [],
                    brand: [],
                    technology: [],
                    bestFor: [],
                    material: [],
                  })
                }
                className="text-pink-600 font-semibold"
              >
                CLEAR ALL
              </button>
              <button onClick={() => setShowMobileFilters(false)}>
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          </div>
          <div className="flex flex-1 overflow-hidden">
            <div className="w-2/5 bg-gray-50 border-r border-gray-300 overflow-y-auto">
              <button
                onClick={() => setSelectedMobileFilterCategory('brands')}
                className={`w-full text-left px-4 py-4 border-b border-gray-200 flex items-center justify-between ${
                  selectedMobileFilterCategory === 'brands' ? 'bg-white border-l-4 border-l-pink-600 font-semibold' : ''
                }`}
              >
                <span className="text-sm">Brands</span>
                {selectedFilters.brand.length > 0 && (
                  <span className="text-xs bg-pink-100 text-pink-600 px-2 py-1 rounded-full mr-2">
                    {selectedFilters.brand.length}
                  </span>
                )}
                <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </button>
              {[
                { id: 'gender', label: 'Gender', count: selectedFilters.gender.length },
                { id: 'price', label: 'Shop By Price', count: selectedFilters.price.length },
                { id: 'colour', label: 'Colour', count: selectedFilters.colour.length },
              ].map((category) => (
                <button
                  key={category.id}
                  onClick={() => setSelectedMobileFilterCategory(category.id)}
                  className={`w-full text-left px-4 py-4 border-b border-gray-200 flex items-center justify-between ${
                    selectedMobileFilterCategory === category.id ? 'bg-white border-l-4 border-l-pink-600 font-semibold' : ''
                  }`}
                >
                  <span className="text-sm">{category.label}</span>
                  {category.count > 0 && (
                    <span className="text-xs bg-pink-100 text-pink-600 px-2 py-1 rounded-full mr-2">{category.count}</span>
                  )}
                  <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </button>
              ))}
            </div>
            <div className="flex-1 overflow-y-auto p-4">
              {selectedMobileFilterCategory === 'brands' && (
                <div className="space-y-2">
                  {subcategoryBrands.map((brand) => (
                    <label key={brand} className="flex items-center py-2">
                      <input
                        type="checkbox"
                        className="mr-3 w-5 h-5"
                        checked={selectedFilters.brand.includes(brand)}
                        onChange={() => handleFilterChange('brand', brand)}
                      />
                      <span className="text-sm">{brand}</span>
                    </label>
                  ))}
                </div>
              )}
              {selectedMobileFilterCategory === 'gender' && (
                <div className="space-y-2">
                  {['Men'].map((item) => (
                    <label key={item} className="flex items-center py-2">
                      <input
                        type="checkbox"
                        className="mr-3 w-5 h-5"
                        checked={selectedFilters.gender.includes(item)}
                        onChange={() => handleFilterChange('gender', item)}
                      />
                      <span className="text-sm">{item}</span>
                    </label>
                  ))}
                </div>
              )}
              {selectedMobileFilterCategory === 'price' && (
                <div className="space-y-2">
                  {['Under ₹ 2 500.00', '₹ 2 501.00 - ₹ 7 500.00', '₹ 7 501.00 - ₹ 12 999.00', 'Over ₹ 13 000.00'].map(
                    (range) => (
                      <label key={range} className="flex items-center py-2">
                        <input
                          type="checkbox"
                          className="mr-3 w-5 h-5"
                          checked={selectedFilters.price.includes(range)}
                          onChange={() => handleFilterChange('price', range)}
                        />
                        <span className="text-sm">{range}</span>
                      </label>
                    )
                  )}
                </div>
              )}
              {selectedMobileFilterCategory === 'colour' && (
                <div className="grid grid-cols-3 gap-4">
                  {[
                    { name: 'Black', color: '#000000' },
                    { name: 'Blue', color: '#0080FF' },
                    { name: 'Brown', color: '#8B4513' },
                    { name: 'Green', color: '#90EE90' },
                    { name: 'Grey', color: '#808080' },
                    { name: 'Orange', color: '#FF6600' },
                    { name: 'Pink', color: '#FF69B4' },
                    { name: 'Purple', color: '#800080' },
                    { name: 'Red', color: '#FF0000' },
                    { name: 'White', color: '#FFFFFF' },
                    { name: 'Yellow', color: '#FFFF00' },
                  ].map((item) => (
                    <div
                      key={item.name}
                      className="flex flex-col items-center cursor-pointer"
                      onClick={() => handleFilterChange('colour', item.name)}
                    >
                      <div
                        className={`w-12 h-12 rounded-full border-2 ${
                          selectedFilters.colour.includes(item.name)
                            ? 'border-pink-600 ring-2 ring-pink-200'
                            : 'border-gray-300'
                        }`}
                        style={{ backgroundColor: item.color }}
                      />
                      <span className="text-xs mt-1">{item.name}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
          <div className="sticky bottom-0 bg-white border-t border-gray-300 p-4">
            <button onClick={() => setShowMobileFilters(false)} className="w-full bg-pink-600 text-white py-4 rounded font-semibold">
              APPLY
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Vests;
